export const DEFAULT_VOLUME = 0.4;
export const VOLUME_KEY_IN_LS = 'workout-volume';
